export const governmentSelectAssessmentPageConstants = {
    headerText: '검사 선택하기',
};
